export const PrivacySection3 = () => {
  return (
    <>
      <section>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          5. How We Use Your Information
        </h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>We use the collected information for various purposes:</p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>To provide, maintain, and improve our Service</li>
            <li>To manage your account and provide customer support</li>
            <li>To enable lead management and conversation tracking features</li>
            <li>To generate AI-powered responses to customer inquiries</li>
            <li>To provide analytics and insights about your business performance</li>
            <li>To send you service-related notifications and updates</li>
            <li>To detect, prevent, and address technical issues and fraud</li>
            <li>To comply with legal obligations</li>
            <li>To send marketing communications (with your consent)</li>
          </ul>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          6. Data Sharing and Disclosure
        </h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            We do not sell your personal information. We may share your information in the following
            circumstances:
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">6.1 Service Providers</h3>
          <p>
            We may share your information with third-party service providers who perform services on
            our behalf, such as:
          </p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Cloud hosting providers (for data storage)</li>
            <li>AI service providers (for generating automated responses)</li>
            <li>Analytics providers (to understand platform usage)</li>
            <li>Email service providers (for notifications)</li>
          </ul>
          <p>
            These providers are contractually obligated to protect your data and use it only for the
            purposes we specify.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">6.2 Legal Requirements</h3>
          <p>
            We may disclose your information if required by law or in response to valid legal
            requests, such as:
          </p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Court orders or subpoenas</li>
            <li>Law enforcement requests</li>
            <li>Legal proceedings or government investigations</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">6.3 Business Transfers</h3>
          <p>
            If WinGrow is involved in a merger, acquisition, or asset sale, your personal
            information may be transferred. We will provide notice before your information is
            transferred and becomes subject to a different Privacy Policy.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">6.4 With Your Consent</h3>
          <p>We may share your information for other purposes with your explicit consent.</p>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Data Security</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            We take the security of your personal information seriously and implement appropriate
            technical and organizational measures to protect it:
          </p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>
              <strong>Encryption:</strong> Data is encrypted in transit (HTTPS/TLS) and at rest
            </li>
            <li>
              <strong>Access Controls:</strong> Strict access controls limit who can view your data
            </li>
            <li>
              <strong>Security Monitoring:</strong> Continuous monitoring for security threats
            </li>
            <li>
              <strong>Regular Audits:</strong> Regular security audits and updates
            </li>
            <li>
              <strong>Secure Authentication:</strong> Industry-standard authentication methods
            </li>
          </ul>
          <p>
            However, no method of transmission over the Internet or electronic storage is 100%
            secure. While we strive to use commercially acceptable means to protect your personal
            information, we cannot guarantee its absolute security.
          </p>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Your Rights</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>You have the following rights regarding your personal information:</p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>
              <strong>Right to Access:</strong> Request a copy of the personal information we hold
              about you
            </li>
            <li>
              <strong>Right to Correct:</strong> Request correction of inaccurate or incomplete
              information
            </li>
            <li>
              <strong>Right to Delete:</strong> Request deletion of your personal information (see
              Section 4)
            </li>
            <li>
              <strong>Right to Opt-Out:</strong> Opt-out of marketing communications at any time
            </li>
            <li>
              <strong>Right to Data Portability:</strong> Request a copy of your data in a
              structured, machine-readable format
            </li>
            <li>
              <strong>Right to Object:</strong> Object to processing of your personal information in
              certain circumstances
            </li>
            <li>
              <strong>Right to Withdraw Consent:</strong> Withdraw consent where processing is based
              on consent
            </li>
          </ul>
          <p>
            To exercise any of these rights, please contact us at{' '}
            <a
              href="mailto:viprielt24@gmail.com"
              className="text-blue-600 underline hover:text-blue-800"
            >
              viprielt24@gmail.com
            </a>
            .
          </p>
        </div>
      </section>
    </>
  );
};
